import * as yup from "yup";

export const schema = yup.object().shape({
  paymentkey: yup.string().nullable().when("paymentoption", { is: "smsbased", then: yup.string().required().matches(/^[0-9.]+$/, "Must be key") }),
  paymentupi: yup
      .string()
      .nullable()
      .when("paymentoption", {
        is: (val) => Array.isArray(val) && val.includes("upibased"), // check array
        then: yup
            .string()
            .required("UPI ID is required")
            .matches(/^[\w.-]+@[\w.-]+$/, "Must be a valid UPI ID"),
      })
});

export const getTextfieldDataSMSbased = (paymentkey) => [
  {
    label: "Gateway Key",
    value: paymentkey,
    onChangeField: "paymentkey",
  },
];

export const getTextfieldDataUPIbased = (paymentupi) => [
  {
    label: "UPI",
    value: paymentupi,
    onChangeField: "paymentupi",
  },
];

export const getRadioButtonData = (paymentoption) => [
  {
    label: "Payment",
    value: paymentoption,
    onChangeField: "paymentoption",
  },
];

export const getCheckboxPayments = (/*codbased,*/ upibased/*, viagateway*/) => [
    /*
  {
    label: "Cash on Delivery (Direct to shop)",
    value: codbased,
    onChangeField: "codbased",
  },
  */

    /*
  {
    label: "Via Gateway",
    value: viagateway,
    onChangeField: "viagateway",
  },
     */
  {
    label: "UPI (Direct to shop)",
    value: upibased,
    onChangeField: "upibased",
  },

];

export const getButtonData = (onFinish, cancelEdit, hasError, isTouched) => [
  {
    name: "Save",
    onClick: onFinish,
    vairant: "contained",
    type: "primary",
    disabled: hasError() || !isTouched(),
  },
  {
    name: "Cancel",
    onClick: cancelEdit,
    vairant: "outlined",
    type: "primary",
    disabled: false,
  },
];
